import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".RequiredStar_root__qZpQW{color:var(--danger-color)!important;pointer-events:none;position:absolute;right:2px;top:2px;transform:scale(.6)}.RequiredStar_inline__328Ou{position:relative;transform:translateY(-.5em)}";
var S = {"root":"RequiredStar_root__qZpQW","inline":"RequiredStar_inline__328Ou"};
styleInject(css_248z);

export { S as default };
